import { render, staticRenderFns } from "./ViewObjects.vue?vue&type=template&id=0ed859ca&"
import script from "./ViewObjects.vue?vue&type=script&lang=js&"
export * from "./ViewObjects.vue?vue&type=script&lang=js&"
import style0 from "./ViewObjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports